let state;
// This function prevents circular depecies.
function initializeLanguageValue(_state) {
	state = _state;
}
/**
 * Method return value of the current language and if it is not avaible it takse fallback language
 * @param {*} object languageObject has strucute f.e. { de: 'Titel', en:'Title', languageIsoName : value }
 * @param {*} state
 */
function getLangValue(object) {
	if (typeof object !== 'object') return object; // if language value is nubmer, string,etc return
	const language = state.persistent.language;
	const defaultLanguage = state.defaultLanguage;
	/* eslint-disable no-nested-ternary */
	return object[language]
		? object[language]
		: object[defaultLanguage]
		? object[defaultLanguage]
		: object[Object.keys(object)[0]];
}
function getLanguageContentWithFallback(languageContentArray) {
	const properties = Object.keys(languageContentArray[0]);
	return properties.reduce(
		(acc, property) =>
			Object.assign(acc, { [property]: getValueLanguageConent(languageContentArray, property) }),
		{}
	);
}
/**
 * This method is used on languageContent arrays to get language sensitive value
 * @param {*} array every array entry is an obejct with fields languageISO and key
 * @param {*} key is f.e. : title, description, cover
 * @param {*} state
 */
function getValueLanguageConent(array, key) {
	return getLangValue(
		array.reduce((acc, content) => {
			acc[content.languageISO] = content[key];
			return acc;
		}, {})
	);
}

function getLangLanguageConent(array) {
	return getLangValue(
		array.reduce((acc, value) => {
			acc[value.languageISO] = value;
			return acc;
		}, {})
	);
}

function getMultipleLangValues(object, props) {
	return props.reduce((acc, prop) => {
		acc[prop] = getLangValue(object[prop]);
		return acc;
	}, {});
}

export {
	getLangValue,
	getLanguageContentWithFallback,
	getLangLanguageConent,
	getMultipleLangValues,
	getValueLanguageConent,
	initializeLanguageValue,
};
